import { Loader2 } from 'lucide-react';

import type { AnalystReportStatus } from '@repo/shared-types';

const STYLES: Record<AnalystReportStatus, string> = {
  PENDING: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  GENERATING: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  COMPLETED: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  FAILED: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
};

const LABELS: Record<AnalystReportStatus, string> = {
  PENDING: 'Queued',
  GENERATING: 'Analysing',
  COMPLETED: 'Ready',
  FAILED: 'Failed',
};

export function StatusPill({ status }: { status: AnalystReportStatus }) {
  const busy = status === 'PENDING' || status === 'GENERATING';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${STYLES[status]}`}
    >
      {busy && <Loader2 className="h-3 w-3 animate-spin" />}
      {LABELS[status]}
    </span>
  );
}
